
import React from "react";
import Menu from "./Componentes/menu";
import Banner from "./Componentes/banner";
import Solucoes from "./Componentes/solucoes";
import Parceiros from "./Componentes/parceiros";
import Projetos from "./Componentes/projetos";
import Footer from "./Componentes/footer";
import "./site.css";

function Site() {
  return (
    <div className="site">
      <Menu />
      <main>
        <Banner />
        <Solucoes />
        <Parceiros />
        <Projetos />
      </main>
      <Footer />
    </div>
  );
}

export default Site;
